import { useContext } from "react";
import classnames from "classnames";

import RangeSlider from "@stadium/ui/src/components/slider/range-slider";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import { getPriceRangeMarkers } from "@helpers/products/search";
import { ProductListingContext } from "@components/store/products/listing/listing-provider";

import style from "./filter-dropdown/filterDropdown.module.scss";
import styleListing from "./listing-header.module.scss";

const emptyArr = [];

/**
 * Header/dropdown price filter: checkbox enable matches legacy (no URL flicker on check alone).
 * Clearing the checkbox tracks once; thumbs use onAfterChange.
 */
const PriceRangeSlider = ({
  items,
  onChange,
  onBeforeChange,
  onAfterChange,
  onCommit,
  selectedIds,
}) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const { isPriceRangeFilterEnabled, setIsPriceRangeFilterEnabled } =
    useContext(ProductListingContext);

  const { min = 0, max = 0, step, currencySymbol } = items;

  const [minValSelected, maxValSelected] = getPriceRangeMarkers(selectedIds);

  const onChangeCheckbox = () => {
    const baseline = Array.isArray(selectedIds) ? [...selectedIds] : [];
    if (isPriceRangeFilterEnabled) {
      onChange(emptyArr);
      onCommit?.(emptyArr, baseline);
      return;
    }
    onChange([min, max]);
    setIsPriceRangeFilterEnabled(true);
    onCommit?.([min, max], baseline);
  };

  return (
    <>
      <div
        className={classnames(`${style.filterDropdownItem} ${style.csCheckbox}`, {
          [style["active"]]: isPriceRangeFilterEnabled,
          "": !isPriceRangeFilterEnabled,
        })}
      >
        <label className={`${styleListing.labelText}`}>
          <input type="checkbox" checked={isPriceRangeFilterEnabled} onChange={onChangeCheckbox} />
          <span className={`${style.csSpan} ${styleListing.csSpanLabel}`}>
            <i
              className={classnames({
                iconCheckboxTick: isPriceRangeFilterEnabled,
                iconCheckboxDefault: !isPriceRangeFilterEnabled,
              })}
            />
            Select Range ({currencySymbol})
          </span>
        </label>
      </div>
      {(isPriceRangeFilterEnabled || !isMobileDevice) && (
        <div className="sm-rc-slider">
          <RangeSlider
            min={min}
            max={max}
            value={selectedIds}
            onChange={onChange}
            onBeforeChange={onBeforeChange}
            onAfterChange={onAfterChange}
            step={step}
            disabled={!isPriceRangeFilterEnabled}
          />
          <div className={styleListing.rcSliderMarks}>
            <div>{minValSelected}</div>
            {isPriceRangeFilterEnabled ? <div>{maxValSelected}</div> : null}
          </div>
        </div>
      )}
    </>
  );
};

export default PriceRangeSlider;
